import { cloneDeep } from 'lodash';
import { defineStore } from 'pinia';

import { TutorialType, TutorialState } from '@/types/components';
import { MIN_TUTORIAL_STEP, initialTutorial } from '@/utils/constants/tutorial';

export const useTutorialStore = defineStore(
  'tutorial',
  () => {
    const tutorials = reactive<Record<TutorialType, TutorialState>>(cloneDeep(initialTutorial()));

    const getTutorial = (type: TutorialType): TutorialState => {
      return tutorials[type] ?? ({} as TutorialState);
    };

    const setTutorialStep = (type: TutorialType, isNext: boolean) => {
      if (!['userGuide', 'chat', 'audienceChat', 'singleChat'].includes(type)) {
        return;
      }

      const delta = isNext ? 1 : -1;
      const nextStep = Math.min(Math.max(tutorials[type].step + delta, MIN_TUTORIAL_STEP), tutorials[type].maxStep);

      if (tutorials[type].maxStep === tutorials[type].step) {
        setTutorialComplete(type);
      }

      tutorials[type].step = nextStep;
    };

    const setTutorialComplete = (type: TutorialType) => {
      tutorials[type].isCompleted = true;
    };

    return {
      tutorials,
      getTutorial,
      setTutorialStep,
      setTutorialComplete,
    };
  },
  { persist: true }
);
